import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { ModalHeaderDefault } from '@/shared/ui/modal';

type LeaveSpaceConfirmationModalProps = {
  isLoading: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onLeave: () => void;
};

export const LeaveSpaceConfirmationModal = ({
  isLoading,
  isOpen,
  onCancel,
  onLeave,
}: LeaveSpaceConfirmationModalProps) => {
  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title="Would you like to leave this space?"
        style={{
          paddingBottom: 0,
        }}
        subtitle="Once you leave, you will lose access to all projects in this space."
        onClose={onCancel}
      />
      <ModalActions>
        <Button variant="outlined" fullWidth onClick={onCancel}>
          Cancel
        </Button>
        <Button isLoading={isLoading} variant="error" fullWidth onClick={onLeave}>
          Leave
        </Button>
      </ModalActions>
    </Modal>
  );
};
